module.exports = __webpack_public_path__ + "static/media/35.a8f59243.jpg";